import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as m, useCallback as r } from "react";

function b() {
  var g = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _m = m(g),
      _m2 = _slicedToArray(_m, 2),
      t = _m2[0],
      l = _m2[1],
      u = r(function (e) {
    return l(function (a) {
      return a | e;
    });
  }, [t]),
      n = r(function (e) {
    return Boolean(t & e);
  }, [t]),
      o = r(function (e) {
    return l(function (a) {
      return a & ~e;
    });
  }, [l]),
      s = r(function (e) {
    return l(function (a) {
      return a ^ e;
    });
  }, [l]);

  return {
    flags: t,
    addFlag: u,
    hasFlag: n,
    removeFlag: o,
    toggleFlag: s
  };
}

export { b as useFlags };